// @ vendors
const moment = require('moment');

// @ helpers
const { getSplittedNumber } = require('utilities/currencyHelper');

// @ constants
const { RECEIPT_STATUS: { PAID } } = require('../insuranceConstants/insuranceRequestTypes');
const { DATE_FORMAT_API } = require('constants/index');


const getLastPayment = (policyInfo) => {
    const receipt = policyInfo.get('receipt');

    if (receipt.size === 1) {
        return receipt.getIn([0, 'totalAmount']);
    }

    const paidOrInProcessReceipt = receipt.reduce((lastReceipt, currentReceipt) => {
        const lastReceiptStatus = lastReceipt.get('receiptStatus');
        const lastReceiptEndDate = lastReceipt.get('receiptEndDate');
        const currentReceiptStatus = currentReceipt.get('receiptStatus');
        const currentReceiptEndDate = currentReceipt.get('receiptEndDate');

        const momentLastReceiptEndDate = moment(lastReceiptEndDate, DATE_FORMAT_API);
        const momentCurrentReceiptEndDate = moment(currentReceiptEndDate, DATE_FORMAT_API);
        let newDate;

        const isCurrentReceiptPaid = currentReceiptStatus === PAID;
        const isLastReceiptPaid = lastReceiptStatus === PAID;

        if (isCurrentReceiptPaid && isLastReceiptPaid) {
            newDate = moment.max(momentLastReceiptEndDate, momentCurrentReceiptEndDate);
        } else if (!isCurrentReceiptPaid && !isLastReceiptPaid) {
            newDate = moment.min(momentLastReceiptEndDate, momentCurrentReceiptEndDate);
        } else if (isCurrentReceiptPaid && !isLastReceiptPaid) {
            return currentReceipt;
        } else {
            return lastReceipt;
        }

        lastReceipt = (newDate === momentLastReceiptEndDate) ? lastReceipt : currentReceipt;

        return lastReceipt;
    });

    return paidOrInProcessReceipt.get('totalAmount');
};

const formatPercentage = percentage => {
    const percentageObj = getSplittedNumber(percentage, null, 2);
    const percentageText = percentageObj.decimals > 0 ?
        `${percentageObj.whole}${percentageObj.decimalMark}${percentageObj.decimals}` :
        percentageObj.whole;

    return percentageText;
}

export {
    getLastPayment,
    formatPercentage
};